import API from '../dataApi';

export const getEventDonations = (eventId, derasarId) =>
  API.get('/event-donations', { params: { eventId, derasarId } });

export const saveEventDonations = (eventId, data) =>
  API.post(`/event-donations/event/${eventId}`, data);

export const registerSpecialDonation = (eventDonationId, payload) =>
  API.post(`/event-donations/${eventDonationId}/register`, payload);

export const unregisterSpecialDonation = (eventDonationId, personId) =>
  API.delete(`/event-donations/${eventDonationId}/register`, { data: { personId } });

export const getEventDonationRegistrations = (eventDonationId) =>
  API.get(`/event-donations/${eventDonationId}/registrations`);

export const settleSpecialDonation = (eventDonationId, data) =>
  API.post(`/event-donations/${eventDonationId}/settle`, data);

export const getBlindOfferRegistrations = (eventId, derasarId) =>
  API.get(`/event-donations/event/${eventId}/blind-offers`, { params: { eventId, derasarId } });
